const alwaysTrue = () => true;

const toItineraryPredicate = (createSegmentPredicate) => (filterRequest) => {
  const getSegmentPredicate = (index) =>
    filterRequest[index]
      ? createSegmentPredicate(filterRequest[index])
      : alwaysTrue;
  return (itinerary) => {
    if (filterRequest.length === 0) {
      return true;
    }
    const { legs } = itinerary;
    return legs.every((leg, index) => {
      const segmentPredicate = getSegmentPredicate(index);
      return segmentPredicate(leg.segments[0]);
    });
  };
};

export default toItineraryPredicate;
